// Office formatting helpers. Display only — nothing here does arithmetic on
// money. Every figure shown in Office is a string or number the server sent.

const USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/** '$1,234.50' from a number or numeric string the server returned; '—' when there is none. */
export function fmtMoney(n) {
  if (n === null || n === undefined || n === '') return '—';
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return USD.format(v);
}

/** Two-decimal hours for a column; never used to compute pay. */
export function fmtHours(h) {
  const v = Number(h);
  if (!Number.isFinite(v)) return '0.00';
  return v.toFixed(2);
}

/** Today's local calendar date as YYYY-MM-DD (the shape every DATE column has). */
export function todayIso(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * A DATE column ('2026-09-01') as 'Sep 1, 2026'. Parsed at local noon so it is
 * never a day out west of Greenwich (dateOnlyBoundaries.test.js).
 */
export function fmtDate(iso) {
  if (typeof iso !== 'string' || !/^\d{4}-\d{2}-\d{2}/.test(iso)) return '—';
  const noon = new Date(`${iso.slice(0, 10)}T12:00:00`);
  if (Number.isNaN(noon.getTime())) return '—';
  return noon.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/** Two DATE columns as 'Sep 1 – Sep 7, 2026'. */
export function fmtDateRange(startIso, endIso) {
  if (!startIso && !endIso) return '—';
  if (!endIso) return fmtDate(startIso);
  if (!startIso) return fmtDate(endIso);
  const a = new Date(`${String(startIso).slice(0, 10)}T12:00:00`);
  const b = new Date(`${String(endIso).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return `${fmtDate(startIso)} – ${fmtDate(endIso)}`;
  const sameYear = a.getFullYear() === b.getFullYear();
  const left = a.toLocaleDateString('en-US', sameYear ? { month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' });
  return `${left} – ${fmtDate(endIso)}`;
}

/**
 * A DATETIME column as the server writes it ('2026-09-01 15:04:05', UTC) or an
 * ISO string, rendered in the viewer's zone: 'Sep 1, 2026, 3:04 PM'.
 */
export function fmtDateTime(value) {
  if (!value) return '—';
  let s = String(value);
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(s)) s = `${s.replace(' ', 'T')}Z`;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}

/** '6.35%' from a numeric rate; '—' when none. */
export function fmtPct(n) {
  if (n === null || n === undefined || n === '') return '—';
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return `${v}%`;
}
